<app-display-card>
  <div
    class="row justify-content-between align-items-center"
    (click)="collapseAutoLiabilities = !collapseAutoLiabilities"
  >
    <div class="col-4">
      <h3>Automotive Liabilities</h3>
    </div>

    <div class="col-3 text-end">
      <i
        class="bi bi-chevron-{{
          collapseAutoLiabilities ? 'up' : 'down'
        }} fs-32 fw-semibold"
      ></i>
    </div>
  </div>

  @if (complianceSettingForms) {
    <div class="inner-panel rounded" [(ngbCollapse)]="collapseAutoLiabilities">
      @if (!collapseAutoLiabilities) {
        <div class="row mx-2">
          <div class="col">
            <div class="row">
              <div class="col-3"></div>
              @for (form of complianceSettingForms; track form) {
                <div class="col-3 d-flex flex-column">
                  <label class="form-label align-self-center">{{
                    form && form.controls.riskLevel.value === 0
                      ? 'Global'
                      : 'Risk Level ' + form.controls.riskLevel.value
                  }}</label>
                </div>
              }
            </div>
            <div class="row py-2">
              <div class="col-3">
                <label class="form-label">Policy Required?</label>
              </div>
              @for (form of complianceSettingForms; track form) {
                <div class="col-3">
                  <form [formGroup]="form">
                    <div class="form-check-group mt-0">
                      <input
                        id="autoLiability_policyRequired{{
                          form.controls.id.value
                        }}"
                        type="checkbox"
                        class="form-check-input"
                        (change)="onAutoLiabilityIsRequiredChange()"
                        formControlName="autoLiability_isRequired"
                      />
                      <label
                        for="autoLiability_policyRequired{{
                          form.controls.id.value
                        }}"
                        class="form-check-label"
                        >Required?</label
                      >
                    </div>
                  </form>
                </div>
              }
            </div>
            <div class="row py-2">
              <div class="col-3">
                <label class="form-label">A.M. Best Rating</label>
              </div>
              @for (form of complianceSettingForms; track form) {
                <div class="col-3">
                  <form [formGroup]="form">
                    <div class="form-group">
                      <select
                        class="form-select"
                        formControlName="autoLiability_amBestRating"
                      >
                        @for (
                          item of amBestValueMap
                            | keyvalue: keyValuePairDefaultOrder;
                          track item
                        ) {
                          <option [ngValue]="item.value">
                            {{ item.key }}
                          </option>
                        }
                      </select>
                    </div>
                  </form>
                </div>
              }
            </div>
            <div class="row py-2">
              <div class="col-3">
                <label class="form-label"
                  >Waive Non-Rated A.M. Best Rating Carriers?</label
                >
              </div>
              @for (form of complianceSettingForms; track form) {
                <div class="col-3">
                  <form [formGroup]="form">
                    <div class="form-check-group">
                      <input
                        id="autoLiability_AllowNRRatedAMBestCarriers{{
                          form.controls.id.value
                        }}"
                        type="checkbox"
                        class="form-check-input"
                        formControlName="autoLiability_AllowNRRatedAMBestCarriers"
                      />
                      <label
                        for="autoLiability_AllowNRRatedAMBestCarriers{{
                          form.controls.id.value
                        }}"
                        class="form-check-label"
                        >Waive</label
                      >
                    </div>
                  </form>
                </div>
              }
            </div>
            <div class="row py-2">
              <div class="col-3">
                <label class="form-label">A.M. Best Financial Size</label>
              </div>
              @for (form of complianceSettingForms; track form) {
                <div class="col-3">
                  <form [formGroup]="form">
                    <div class="form-group">
                      <select
                        class="form-select"
                        formControlName="autoLiability_financialSizeCategory"
                      >
                        @for (
                          item of amBestFinancialValueMap
                            | keyvalue: keyValuePairDefaultOrder;
                          track item
                        ) {
                          <option [ngValue]="item.value.value">
                            {{ item.key }}
                          </option>
                        }
                      </select>
                    </div>
                  </form>
                </div>
              }
            </div>
            <div class="row py-2">
              <div class="col">
                <div class="row">
                  <div class="col-3">
                    <label class="form-label">Combined Single Limit</label>
                  </div>
                  @for (form of complianceSettingForms; track form) {
                    <div class="col-3">
                      <form [formGroup]="form">
                        <div class="form-group">
                          <!-- <select class="form-select" formControlName="autoLiability_combinedSingleLimit">
                                <option *ngFor="let item of combinedSingleLimitMap | keyvalue: keyValuePairDefaultOrder" [ngValue]="item.value">{{ item.key }}</option>
                              </select> -->
                          <div class="input-group">
                            <span class="input-group-text">$</span>
                            <input
                              type="text"
                              class="form-control"
                              placeholder="Enter Amount"
                              [inputMask]="currencyMask"
                              (ngModelChange)="
                                applyCurrencyFormat(
                                  form.controls[
                                    'autoLiability_combinedSingleLimit'
                                  ],
                                  $event
                                )
                              "
                              [formControl]="
                                form.controls[
                                  'autoLiability_combinedSingleLimit'
                                ]
                              "
                            />
                          </div>
                        </div>
                      </form>
                    </div>
                  }
                </div>
                <span class="fw-bold ps-5">OR</span>
                <div class="row">
                  <div class="col-3">
                    <label class="form-label">Property Damage Limit</label>
                  </div>
                  @for (form of complianceSettingForms; track form) {
                    <div class="col-3">
                      <form [formGroup]="form">
                        <div class="form-group">
                          <div class="input-group">
                            <span class="input-group-text">$</span>
                            <input
                              type="text"
                              class="form-control"
                              placeholder="Enter Amount"
                              [inputMask]="currencyMask"
                              (ngModelChange)="
                                applyCurrencyFormat(
                                  form.controls[
                                    'autoLiability_propertyDamageLimit'
                                  ],
                                  $event
                                )
                              "
                              [formControl]="
                                form.controls[
                                  'autoLiability_propertyDamageLimit'
                                ]
                              "
                            />
                          </div>
                        </div>
                      </form>
                    </div>
                  }
                </div>
              </div>
            </div>
            <div class="row py-2">
              <div class="col-3">
                <label class="form-label">Bodily Injury per Person</label>
              </div>
              @for (form of complianceSettingForms; track form) {
                <div class="col-3">
                  <form [formGroup]="form">
                    <div class="form-group">
                      <div class="input-group">
                        <span class="input-group-text">$</span>
                        <input
                          type="text"
                          class="form-control"
                          placeholder="Enter Amount"
                          [inputMask]="currencyMask"
                          (ngModelChange)="
                            applyCurrencyFormat(
                              form.controls[
                                'autoLiability_bodilyInjuryPerPerson'
                              ],
                              $event
                            )
                          "
                          [formControl]="
                            form.controls['autoLiability_bodilyInjuryPerPerson']
                          "
                        />
                      </div>
                    </div>
                  </form>
                </div>
              }
            </div>
            <div class="row py-2">
              <div class="col-3">
                <label class="form-label">Bodily Injury per Accident</label>
              </div>
              @for (form of complianceSettingForms; track form) {
                <div class="col-3">
                  <form [formGroup]="form">
                    <div class="form-group">
                      <div class="input-group">
                        <span class="input-group-text">$</span>
                        <input
                          type="text"
                          class="form-control"
                          placeholder="Enter Amount"
                          [inputMask]="currencyMask"
                          (ngModelChange)="
                            applyCurrencyFormat(
                              form.controls[
                                'autoLiability_bodilyInjuryPerAccident'
                              ],
                              $event
                            )
                          "
                          [formControl]="
                            form.controls[
                              'autoLiability_bodilyInjuryPerAccident'
                            ]
                          "
                        />
                      </div>
                    </div>
                  </form>
                </div>
              }
            </div>
            @for (
              item of checkBoxFields | keyvalue: keyValuePairDefaultOrder;
              track item
            ) {
              @if (item.value.show) {
                <div class="row py-2">
                  <div class="col-3">
                    <label class="form-label">{{ item.key }}</label>
                  </div>
                  @for (form of complianceSettingForms; track form) {
                    <div class="col-3">
                      <form [formGroup]="form">
                        <div class="form-check-group">
                          <input
                            id="{{ item.key + '_' + form.controls.id.value }}"
                            type="checkbox"
                            class="form-check-input"
                            formControlName="{{ item.value.controlName }}"
                          />
                          <label
                            for="{{ item.key + '_' + form.controls.id.value }}"
                            class="form-check-label"
                            >{{
                              item.value.labelText
                                ? item.value.labelText
                                : 'Required?'
                            }}</label
                          >
                        </div>
                      </form>
                    </div>
                  }
                </div>
              }
            }
          </div>
        </div>
      }
    </div>
  }
</app-display-card>
